import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import logoImg from "../Images/logo40.jpg";

const API = process.env.REACT_APP_API_URL || "";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/api/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || t("error.generic"));
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="spar-card login-card">
        <div className="login-brand">
          <img src={logoImg} alt="SPAR" className="login-logo" />
          <h1 className="spar-page-title">{t("forgot.title")}</h1>
          <p className="login-subtitle">{t("forgot.subtitle")}</p>
        </div>

        {sent ? (
          <p style={{ textAlign: "center", lineHeight: 1.6 }}>{t("forgot.sent")}</p>
        ) : (
          <>
            {error && <div className="spar-alert spar-alert-error">{error}</div>}

            <form onSubmit={handleSubmit} noValidate>
              <div className="spar-form-group">
                <label className="spar-label" htmlFor="forgot-email">
                  {t("forgot.email")}
                </label>
                <input
                  id="forgot-email"
                  type="email"
                  className="spar-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>

              <button
                type="submit"
                className="spar-btn spar-btn-primary"
                disabled={submitting}
                style={{ width: "100%", justifyContent: "center", height: 48 }}
              >
                {submitting ? (
                  <>
                    <span className="spar-spinner" />
                    {t("forgot.submitting")}
                  </>
                ) : (
                  t("forgot.submit")
                )}
              </button>
            </form>
          </>
        )}

        <p style={{ textAlign: "center", marginTop: 16, fontSize: "0.9rem" }}>
          <a href="/login">{t("forgot.backToLogin")}</a>
        </p>
      </div>
    </div>
  );
}
